import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { SROnlyH1 } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function OmeTVAlternative() {
  return (
    <>
      <SEO
        title="Best OmeTV Alternative - Talkvee (Ad-Free & Safer)"
        description="Looking for an OmeTV alternative? Talkvee is safer, ad-free, and features built-in games like Trivia and Tic-Tac-Toe. Join as a guest instantly."
        pathname="/ome-tv-alternative"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "OmeTV Alternative", "item": "https://talkvee.com/ome-tv-alternative" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <div className="landing-banner">
          <strong>Better than OmeTV?</strong> — Talkvee is 100% Ad-Free and includes fun games.
        </div>
        
        <section className="landing-hero">
         <h1 className="landing-title">The Best OmeTV Alternative</h1>
          <p className="landing-subtitle">
            Tired of ads and bots on OmeTV? Talkvee offers a cleaner, faster, and more fun 
            video chat experience with built-in games and interest matching.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Why switch from OmeTV?</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#fee2e2', padding: '20px', borderRadius: '12px', border: '1px solid #fecaca'}}>
              <h4 style={{margin: '0 0 10px', color: '#b91c1c', fontSize: '1.1rem'}}>❌ OmeTV</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#7f1d1d', lineHeight: '1.6'}}>
                <li>Contains Ads</li>
                <li>Basic Chat Only</li>
                <li>Many Bots</li>
              </ul>
            </div>
            <div style={{background: '#dcfce7', padding: '20px', borderRadius: '12px', border: '1px solid #bbf7d0'}}>
              <h4 style={{margin: '0 0 10px', color: '#15803d', fontSize: '1.1rem'}}>✅ Talkvee</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#14532d', lineHeight: '1.6'}}>
                <li>100% Ad-Free</li>
                <li>Trivia & Games</li>
                <li>Strict Moderation</li>
              </ul>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "Is Talkvee really better than OmeTV?",
              a: "We think so! Unlike OmeTV, we don't spam you with ads, and we give you fun icebreaker games to make chatting easier."
            },
            {
              q: "Is it free like OmeTV?",
              a: "Yes, Talkvee is completely free to use. No credits, no subscriptions."
            },
            {
              q: "Do I need to download an app?",
              a: "No. Like OmeTV's web version, Talkvee works directly in your browser, but is lighter and faster."
            }
          ]}
        />
      </div>
    </>
  );
}